import { useState } from "react";
import FixedPage from "./Layout/FixedPage";

export default function Image({
  id,
  filename,
  thumbnail,
  showFullSize = true,
  imageClassName,
}: {
  id?: string;
  filename: string;
  thumbnail?: string;
  showFullSize?: boolean;
  imageClassName?: string;
}) {
  const [isFullSize, setIsFullSize] = useState(false);
  const toggleFullSize = () => setIsFullSize((prev) => !prev);
  return (
    <>
      <div
        className={`flex w-60 items-center justify-center max-h-full p-0 object-contain mb-2 mt-2 ${imageClassName}`}
        onClick={() => {
          if (showFullSize) {
            toggleFullSize();
          }
        }}
      >
        <img
          id={id}
          src={`${filename}`}
          title={filename.split("/").pop()?.split("?")[0]}
          className={`max-h-full rounded-2xl mr-2 cursor-pointer h-full w-full object-contain  ${imageClassName}`}
          alt={filename.split("/").pop()?.split("?")[0] || "Thumbnail"}
        />
      </div>
      {isFullSize && showFullSize && (
        <FixedPage
          fullScreen
          onOutsideClick={() => setIsFullSize(false)}
        >
          <div className="absolute inset-0 box-border flex items-center justify-center overflow-hidden p-4">
            <img
              src={`${filename}`}
              title={filename.split("/").pop()?.split("?")[0]}
              onClick={(e) => {
                e.stopPropagation();
                toggleFullSize();
              }}
              className="max-h-full max-w-full min-h-0 h-auto w-auto rounded-lg object-contain select-none"
              alt="Full Size"
            />
          </div>
        </FixedPage>
      )}
    </>
  );
}
